// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5583":"ba8f5875","6184":"97359ef0","7502":"40a3facd","8576":"a52689a3","8611":"0d5f12da"}[chunkId] + ".chunk.css";
};